import { type HTMLAttributes } from "react";
import { cn } from "../../utils/cn";

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  /** Render as a single line of text-height (h-4 rounded). */
  text?: boolean;
}

/* A pulsing placeholder shown while data loads. Compose several to mirror the
 * shape of the content that will replace them. */
export function Skeleton({ text = false, className, ...rest }: SkeletonProps) {
  return (
    <div
      aria-hidden
      className={cn(
        "animate-pulse rounded-md bg-surface-muted",
        text && "h-4 rounded",
        className,
      )}
      {...rest}
    />
  );
}
